const brands = {
  base: {
    name: "AddACCION",
    primary: "#29ABE2",
    dark: "#474857",
    muted: "#474857",
    headerGradient:
      "linear-gradient(180deg, rgba(59,88,165,1) 0%, rgba(51,120,189,1) 30%, rgba(45,171,227,1) 100%)",
    pageBackground: "#29ABE2",
    logo: "branding/base/logo.svg",
    logoClass: "h-10 w-auto ml-2",
    statusTextColor: "#FFFFFF",
  },
  interceramic: {
    name: "Interceramic",
    primary: "#E40520",
    dark: "#2E2B29",
    muted: "#A39F9E",
    headerGradient:
      "linear-gradient(180deg, rgb(194, 191, 190) 0%, rgba(237, 236, 236, 1) 10%, rgba(237, 236, 236, 1) 100%)",
    pageBackground: "rgba(237, 236, 236, 1)",
    logo: "branding/interceramic/logo.png",
    logoClass: "w-1/4 ml-2",
    statusTextColor: "#9CA3AF",
  },
};

module.exports = {
  defaultBrand: "base",
  brands,
};
